<div
    *ngIf="{ disabled: disabled$ | async } as data"
    class="container"
    [class.disabled]="data.disabled"
    [matTooltip]="tooltip || null"
    (click)="documentClick.emit()"
>
    <div class="icon-container">
        <app-loading-indicator
            *ngIf="loading"
            primary
            class="download-indicator"
        ></app-loading-indicator>
        <ng-container [ngSwitch]="fileType">
            <mat-icon
                *ngSwitchCase="FileType.PDF"
                svgIcon="file-pdf"
                class="icon"
                [class.disabled]="data.disabled"
            ></mat-icon>
            <mat-icon
                *ngSwitchCase="FileType.EXCEL"
                svgIcon="file-excel"
                class="icon"
                [class.disabled]="data.disabled"
            ></mat-icon>
            <mat-icon
                *ngSwitchCase="FileType.CSV"
                svgIcon="file-csv"
                class="icon"
                [class.disabled]="data.disabled"
            ></mat-icon>
            <mat-icon *ngSwitchDefault svgIcon="file" class="icon"></mat-icon>
        </ng-container>
    </div>
    <div>
        {{ date | date: 'dd.MM.yyyy' }}
        <span [ngClass]="{ 'document-badge': showNewDocumentBadge }"></span>
    </div>
    <div data-test="document-name" *ngIf="name">
        {{ name }}
    </div>
    <div *ngIf="sizeInBytes">
        ({{ sizeInBytes! / 1000000 | number: '1.1-2' }} MB)
    </div>
</div>
